// extracted by mini-css-extract-plugin
export default {"p2":"paragraph_p2__NVpiv","errorMessage":"paragraph_errorMessage__cGU6T"};